import { render } from "./NarrowNavigation.vue?vue&type=template&id=356e8352&scoped=true"
import script from "./NarrowNavigation.vue?vue&type=script&lang=js"
export * from "./NarrowNavigation.vue?vue&type=script&lang=js"

import "./NarrowNavigation.vue?vue&type=style&index=0&id=356e8352&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-356e8352"

export default script